import { useState, useEffect } from "react";
import moment from "moment-timezone";

const TimerCell = ({ dateTime, referenceNo }) => {
    // Convert UTC datetime to Asia/Karachi timezone
    const targetTime = moment.utc(dateTime).tz("Asia/Karachi");

    const [timeLeft, setTimeLeft] = useState("");

    const calculateTimeLeft = () => {
        const now = moment().tz("Asia/Karachi"); // Get current time in PKT
        const diff = targetTime.diff(now);

        if (diff <= 0) {
            return "Elapsed";
        }

        const duration = moment.duration(diff);
        const days = Math.floor(duration.asDays());
        const hours = duration.hours();
        const minutes = duration.minutes();
        const seconds = duration.seconds();

        return `${days}d ${hours}h ${minutes}m ${seconds}s`;
    };

    useEffect(() => {
        setTimeLeft(calculateTimeLeft());

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(timer);
    }, [dateTime]);

    // Determine color based on time left
    let color = "green";

    if (timeLeft === "Elapsed") {
        color = "black";
    } else {
        const totalMinutesLeft = moment
            .duration(targetTime.diff(moment().tz("Asia/Karachi")))
            .asMinutes();

        if (totalMinutesLeft <= 180) {
            color = "red";
        } else if (totalMinutesLeft <= 720) {
            color = "orange";
        }
    }

    return <div style={{ color, fontWeight: "bold" }}>{timeLeft}</div>;
};

export default TimerCell;
